


export class SelectQuery<T> {
    ids: T[] | null = null;
    term: string = '';
    page: number = 0;
    discover: boolean = false;

    constructor(init?: Partial<T>) {
        Object.assign(this, init);
    }
}

export class SelectQueryNumber extends SelectQuery<number>  {
}

export class SelectQueryString extends SelectQuery<string>  {
}

